module.exports = __webpack_public_path__ + "img/coupon-popup-item-use.8fb50564.png";